<template>
  <div>
    <div class="content-title">账户充值审核</div>
    <div class="content-table">
      <el-table :data="recharges" size='medium' tooltip-effect="dark">
        <el-table-column prop="payName" label="付款人" width="280px"></el-table-column>
        <el-table-column prop="payAccount" label="付款账户" width="250px"></el-table-column>
        <el-table-column prop="recvName" label="收款人" width="240px"></el-table-column>
        <el-table-column prop="recvAccount" label="收款账户" width="240px"></el-table-column>
        <el-table-column prop="money" label="转账金额" align="right"></el-table-column>
        <el-table-column prop="availMoney" label="账户余额" align="right"></el-table-column>
        <el-table-column prop="payDate" label="付款日期" align="center"></el-table-column>
        <el-table-column prop="rechargeStatus" label="状态" align="center">
          <template slot-scope="scope"><span>{{ scope.row.rechargeStatus | parseChargeStatus }}</span></template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.rechargeStatus == 0" type="primary" size="medium" @click="auditRecharge(scope.row)">审核</el-button>
            <div v-else>-</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'rechargeverify',
  data() {
    return {
      recharges: [],
      accountBalance: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  filters: {
    parseChargeStatus(rechargeStatus) {
      if (rechargeStatus === 0) {
        return '审核中';
      } else if (rechargeStatus === 1) {
        return '审核通过';
      } else if (rechargeStatus === 2) {
        return '审核不通过';
      }
      return '';
    },
  },
  mounted() {
    this.fetchAllRecharges();
  },
  methods: {
    addrecharge() {
      this.$router.push({ path: 'addrecharge' });
    },
    fetchAllRecharges() {
      this.recharges = [];
      api.fetchAllRecharges({
        params: {
          params: {
            index: this.currentPage - 1,
            size: this.pageSize,
          },
        },
      }).then((res) => {
        console.log('fetchAllRecharges', res);
        this.recharges = [];
        this.total = 0;
        if (!res) {
          return;
        }
        this.total = res.count;
        if (!res.data) {
          return;
        }
        this.recharges = res.data;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    auditRecharge(row) {
      const params = {
        rechargeId: row.rechargeId,
      };
      this.$router.push({ path: 'auditrecharge', query: params });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchAllRecharges();
    },
  },
};
</script>

<style lang="less" scoped>

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.content-tool {
  // padding: 27px 17px 20px 17px;
  // border: 1px solid #ebeef5;
  background: #fff;
  font-size: 15px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
    padding: 0px 17px 20px 17px;
    margin: 0px 20px 20px 20px;
  }
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>

<style scoped>
.el-form .el-form-item{
  margin-bottom: 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/rechargeverify.vue